export default () => {
  const emptyValues = Array(48).fill(false);
  return {
    monday: [...emptyValues],
    tuesday: [...emptyValues],
    wednesday: [...emptyValues],
    thursday: [...emptyValues],
    friday: [...emptyValues],
    saturday: [...emptyValues],
    sunday: [...emptyValues],
  };
};
